var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25,58.438l32.604,-0l0,-6.25l-32.604,-0l0,6.25Zm0,-13.542l50,-0l0,-6.25l-50,-0l0,6.25Zm0,-13.542l50,0l0,-6.25l-50,0l0,6.25Zm-16.667,60.313l0,-77.084c0,-1.597 0.625,-3.038 1.875,-4.323c1.25,-1.284 2.709,-1.927 4.375,-1.927l70.834,0c1.597,0 3.038,0.643 4.323,1.927c1.284,1.285 1.927,2.726 1.927,4.323l-0,54.167c-0,1.597 -0.643,3.038 -1.927,4.323c-1.285,1.285 -2.726,1.927 -4.323,1.927l-60.417,-0l-16.667,16.667Zm6.25,-15.105l7.813,-7.812l63.021,-0l-0,-54.167l-70.834,0l0,61.979Zm0,-61.979l0,61.979l0,-61.979Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms-icon.2d42214804097287419f2694434c71b5.svg";
export { ForwardRef as ReactComponent };